import {
    GET_TEAM_MEMBERS_DETAILS_FAILURE,
    GET_TEAM_MEMBERS_DETAILS_REQUEST,
    GET_TEAM_MEMBERS_DETAILS_SUCCESS
} from "../actions";

const initialState = {
    loading: false,
    data: [],
    error: "",
};

const getTeamMemberDetailsByAdminReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_TEAM_MEMBERS_DETAILS_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
            };

        case GET_TEAM_MEMBERS_DETAILS_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: "",
            };
        case GET_TEAM_MEMBERS_DETAILS_FAILURE:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
};
export default getTeamMemberDetailsByAdminReducer;
